import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TitledCardComponent } from './titled-card.component';

@NgModule({
  declarations: [TitledCardComponent],
  imports: [CommonModule],
  exports: [TitledCardComponent],
})
export class TitledCardModule {}
